import {create} from 'zustand';
import type {ClosetItem, ViewMode, SortOption} from '@/types';

interface ClosetState {
  items: ClosetItem[];
  activeMemberId: string;
  activeCategoryName: string | null;
  searchQuery: string;
  sortOption: SortOption;
  viewMode: ViewMode;
}

interface ClosetActions {
  setItems: (items: ClosetItem[]) => void;
  setActiveMember: (memberId: string) => void;
  setActiveCategory: (categoryName: string | null) => void;
  toggleCategory: (categoryName: string) => void;
  setSearchQuery: (query: string) => void;
  setSortOption: (option: SortOption) => void;
  setViewMode: (mode: ViewMode) => void;
  reset: () => void;
}

const initialState: ClosetState = {
  items: [],
  activeMemberId: 'all',
  activeCategoryName: null,
  searchQuery: '',
  sortOption: 'newest',
  viewMode: 'grid',
};

export const useClosetStore = create<ClosetState & ClosetActions>()((set) => ({
  ...initialState,

  setItems: (items) => {
    set({items});
  },

  setActiveMember: (memberId) => {
    set({activeMemberId: memberId, activeCategoryName: null});
  },

  setActiveCategory: (categoryName) => {
    set({activeCategoryName: categoryName});
  },

  toggleCategory: (categoryName) => {
    set((state) => ({
      activeCategoryName: state.activeCategoryName === categoryName ? null : categoryName,
    }));
  },

  setSearchQuery: (query) => {
    set({searchQuery: query});
  },

  setSortOption: (option) => {
    set({sortOption: option});
  },

  setViewMode: (mode) => {
    set({viewMode: mode});
  },

  reset: () => {
    set(initialState);
  },
}));
